// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-circular-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: #64748b;
  font-size: 0.875rem;
}
.app-circular-loader__spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid #e2e8f0;
  border-top-color: var(--undp-jtf-primary-color, #2563eb);
  border-radius: 50%;
  animation: app-circular-loader-spin 0.7s linear infinite;
}

@keyframes app-circular-loader-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./libs/core/loading/app-circular-loader.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,wDAAA;EACA,kBAAA;EACA,wDAAA;AACJ;;AAGA;EACE;IACE,yBAAA;EAAF;AACF","sourcesContent":[".app-circular-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  color: #64748b;\n  font-size: 0.875rem;\n\n  &__spinner {\n    width: 2rem;\n    height: 2rem;\n    border: 3px solid #e2e8f0;\n    border-top-color: var(--undp-jtf-primary-color, #2563eb);\n    border-radius: 50%;\n    animation: app-circular-loader-spin 0.7s linear infinite;\n  }\n}\n\n@keyframes app-circular-loader-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
